import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';

const andarConditionsOptions = [
  {
    key: Conditions.NewWithTags,
    label: 'New In Box Or Dust Bag',
    shortLabel: 'New in Box or Dust Bag',
    description:
      'Your item has never been worn and you have the original box or dust bag. For this option, you’ll need to take pictures of the box or dust bag.',
  },
  {
    key: Conditions.NewWithoutTags,
    label: 'New Without Box Or Dust Bag',
    shortLabel: 'New w/o Box or Dust Bag',
    description:
      'Your item has never been worn (other than perhaps trying it on), but you no longer have the box or dust bag. There are no quirks or issues whatsoever.',
  },
  {
    key: Conditions.Excellent,
    label: 'Excellent Condition',
    shortLabel: 'Excellent',
    description:
      'Your item has only been lightly used and has been extremely well maintained. There may be some small signs of wear, but nothing major.',
  },
  {
    key: Conditions.Good,
    label: 'Good Condition',
    shortLabel: 'Good',
    description:
      'You’ve worn this item and it’s well maintained. There may be some quirks like a small stain, a button missing, or a loose thread, but it’s overall in good shape. You will need to take pictures of any quirks the item has.',
  },
];

const andarSizes: string[] = ['S', 'M', 'L', 'XL', 'XXL'];

export const andarShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({
      options: andarConditionsOptions,
    }),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({
      sizes: andarSizes,
    }),
  ],
};
